var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-grow-1"},[_c('v-text-field',{attrs:{"counter":_vm.counter,"data-cy":`${_vm.entityName}__textField--${_vm.attributeName}`,"disabled":_vm.disabled,"value":_vm.value,"rules":_vm.autoRules,"outlined":""},on:{"input":_vm.valueUpdate}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }